



































































import AbpBase from "../../../lib/abpbase";
import {Component, Vue, Inject, Prop, Watch} from 'vue-property-decorator';
import {GetUtcodeList, InsertUtcode, UpdateUtcodeById, DeleteUtcode} from '../../../api/specialDictionary'
import {GetPinYin, GetWuBi} from '../../../api/sys'
import {GetListByCode} from '../../../api/configureDictionary'

@Component
export default class Country extends AbpBase {
	cancel(){
		this.dialogFormVisible = false
	}
	visibleChange(value: boolean) {
		if (!value) {
			this.dialogFormVisible = false;
			(this.$refs.form as any).resetFields()
			this.getData()
		}
	}
	columns = [
		{
			key: 'deptName',
			title: '部门名称'
		},
		{
			key: 'deptTypeName',
			title: '部门类型名称'
		},
		{
			key: 'deptPY',
			title: '拼音助记符'
		},
		{
			key: 'deptWB',
			title: '五笔助记符'
		},
		{
			key: 'status',
			title: '是否启用',
			render:(h:any, p:any)=>{
				return h('span', p.row.status ? '启用' : '禁用')
			}
		},
		{
			key: '',
			width: 190,
			title: '操作',
			render:(h:any, p:any)=>{
				return h('div', [
					h('Button',{
						props:{type: 'primary'},
						style:{marginRight:'20px'},
						on:{
							click:()=>{
								this.edit(p.row)
							}
						}
					},'编辑'),
					h('Button',{
						props:{type: 'error'},
						on:{
							click:()=>{
								this.del(p.row)
							}
						}
					},'删除'),
				])
			}
		},
	]
	depts = []  //部门类型下拉
	key = '' //查询条件
	page = 1 //当前页
	dialogTitle = ''
	dialogForm: any = {
		deptPY:'',
		deptWB:''
	}
	dialogFormVisible = false
	dialogFormLabelWidth = '100px'
	tableTotalSize = 0
	tableData = []
	tableLoading = false
	created() {
		this.getData()
	}
	async getCode(val: any){
		let query = {inputStr: val}
		let res1 = await GetPinYin(query)
		let res2 = await GetWuBi(query)
		this.dialogForm.deptPY = res1
		this.dialogForm.deptWB = res2
	}
	createCounty() {
		this.dialogTitle = '新增部门'
		this.dialogForm = {
			status:true,
			deptPY:'',
			deptWB:''
		}
		this.dialogFormVisible = true
	}
	deptChange(val: any){
		this.dialogForm.deptType = val.id
		this.dialogForm.deptTypeName = val.text
	}
	private async getData() {
		this.tableLoading = true
		let res = await GetUtcodeList({
			QueryString: this.key,
			SkipCount: this.page,
			MaxResultCount: 10
		})
		this.tableData = res.items
		this.tableTotalSize = res.totalCount
		this.tableLoading = false
		let res1 = await GetListByCode({input: "020"})
		this.depts = res1
	}

	handleClose() {
		this.dialogFormVisible = false
	}

	edit(row: any) {
		this.dialogTitle = '编辑部门'
		this.dialogForm = JSON.parse(JSON.stringify(row))
		this.dialogFormVisible = true
	}
	async del(row: any){
		this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
			confirmButtonText: '确定',
			cancelButtonText: '取消',
			type: 'warning'
		}).then(async () => {
			let res = await DeleteUtcode({Id: row.id})
			this.getData()
		}).catch(() => {

		});

	}
	async confirm(){
		(this.$refs.form as any).validate(async (valid:boolean)=>{
			if(valid){
				if (this.dialogTitle === '新增部门') {
					let res = await InsertUtcode(this.dialogForm)
				} else if (this.dialogTitle === '编辑部门') {
					let res = await UpdateUtcodeById(this.dialogForm)
				}
				this.dialogFormVisible = false
				this.getData()
			}
		})
	}
	rules = {
		deptName:[{required: true, message: '请输入内容', trigger: 'blur'}],
		deptPY:[{required: true, message: '请输入内容', trigger: 'blur'}],
		deptWB:[{required: true, message: '请输入内容', trigger: 'blur'}],
	}
	pageChange(val: any){
		this.page = val
		this.getData()
	}
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/specialDictionary/department/index.vue